<template>

  <div class="page-table scrollable only-y" v-loading="plotLoading">

    <div class="table-box page-header card-base card-shadow--medium widget call-history-plot-view">
      <div class="flex justify-space-between">
        <h1 class="mt-0">
          {{name}}
        </h1>
        <el-radio-group v-model="presetSelection" @change="doPreset" class="ml-10 hidden-xs-only">
          <el-radio-button type="default" label="last10">Last 10 Days</el-radio-button>
          <el-radio-button label="lastMonth">Last 30 Days</el-radio-button>
        </el-radio-group>
      </div>

      <div :id="'activity-plot-' + direction" style="height: 400px; width:100%;" class="mt-10"></div>
    </div>
  </div>

</template>

<script>

  import feathersClient from "@/feathers/feathers-client";
  import echarts from "echarts";
  import moment from 'moment';
  import {phoneNumberFormatter} from "@/globals/globals";

  export default {
    name: 'ActivityPlot',
    props: {
      direction: {required: true},
      name: {default: null},
      maxTicks: {default: 9},
      branchOptions: {required: true},
      colors: {
        default: () => [
          '#1782FF',
          '#FF6827',
          '#46CA63',
          '#8459FF'
        ]
      },
      colorsSecondary: {
        default: () => [
          '#FFD600',
          '#26B1FF',
          '#ff8f02',
          '#0F85FF'
        ]
      }
    },
    data() {
      return {
        plotLoading: false,
        primaryData: null,
        secondaryData: null,
        chartElement: null,
        chart: null,
        secondaryGroup: null,
        extOptions: [],
        numberOptions: [],
        extNumber: '',
        branch: '',
        phoneNumber: '',
        secondaryOptions: [],
        secondaryOptionsList: [],
        primaryFilter: '',
        presentedFilter: 'Presented',
        dispositions: ['ANSWERED', 'NO ANSWER'],
        primaryLegend: [],
        xInterval: 0,
        presetSelection: 'last10',
        startDate: null,
        endDate: null,
        modalVisible: false,
        advancedActive: false,
        resized: false,
        distribution: 'daily',
        historyDateRange: [
          moment(),
          moment()
        ],
        datePickerOptions: {
          shortcuts: [{
            text: 'Last week',
            onClick(picker) {
              const end = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute');
              const start = moment(moment().subtract(1, 'week').format('YYYY-MM-DD'));
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute');
              const start = moment(moment().subtract(1, 'month').format('YYYY-MM-DD'));
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = moment(moment().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 'minute');
              const start = moment(moment().subtract(3, 'months').format('YYYY-MM-DD'));
              picker.$emit('pick', [start, end]);
            }
          }],
          disabledDate(time) {
            const difference = moment(time).diff(moment(), 'days');
            return !(difference > -181 && difference < 1);
          }
        },
      }
    },
    computed: {
      user(){
        return this.$store.state.auth.user;
      },
      colorTheme(){
        return this.$store.state.layout.theme;
      },
      selectedTenant(){
        return this.$store.state.selectedTenant;
      },
      selectedDateRange(){
        if(this.endDate && this.startDate){
          const dateStart = moment(this.startDate).format('M/D/YY');
          const dateEnd = moment(this.endDate).format('M/D/YY');
          return  `${dateStart} - ${dateEnd}`;
        }
      }
    },
    watch: {
      selectedTenant(){
        this.resetPlot();
      },
      secondaryGroup(){
        const dispositionGroups = ['inboundCalls', 'outboundCalls', 'totalCalls'];
        if(dispositionGroups.includes(this.secondaryGroup)){
          this.secondaryOptionsList = [
            {
              value: 'ANSWERED',
              label: 'Answered'
            },
            {
              value: 'NO ANSWER',
              label: 'No Answer'
            }
          ];
          this.secondaryOptions = this.secondaryOptionsList.map( item => item.value);
          return;
        }
        this.secondaryOptionsList = [];
        this.secondaryOptions = [];
      },
    },
    methods: {
      getSecondaryGroupName(val){
        const map = {
          callQuality: 'Call Quality',
          totalCalls: 'Total Calls',
          internalCalls: 'Internal Calls',
          inboundCalls: 'Inbound Calls',
          outboundCalls: 'Outbound Calls',
          talkTime: 'Talk Time'
        }
        return map[val];
      },
      handleCloseModal(){
        this.modalVisible = false;
      },
      updateDateRangePicker(){
        this.historyDateRange = [
          moment(this.startDate),
          moment(this.endDate)
        ]
      },
      resetPlot(){
        this.dispositions = ['ANSWERED', 'NO ANSWER'];
        this.doPreset('last10');
      },
      doPreset(val){
        this.secondaryGroup = 'outboundCalls';
        this.secondaryOptions = ['ANSWERED', 'NO ANSWER'];
        if(val === 'last10'){
          this.endDate = moment().format('YYYY-MM-DD');
          this.startDate = moment().subtract(9, 'days').format('YYYY-MM-DD');
          this.presetSelection = 'last10';
          this.updateDateRangePicker();
          this.queryData();
        }

        if(val === 'lastMonth'){
          this.endDate = moment().format('YYYY-MM-DD');
          this.startDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
          this.presetSelection = 'lastMonth';
          this.updateDateRangePicker();
          this.queryData();
        }
      },
      getDatesInRange(){

        if (this.distribution === "daily") {
          const dates = [moment(this.startDate).format("YYYY-MM-DD")];
          let currentDate = this.startDate;
          let endDate = moment(this.endDate).format("YYYY-MM-DD");
          while (currentDate < endDate) {
            const nextDay = moment(currentDate).add(1, "day");
            currentDate = nextDay.format("YYYY-MM-DD");
            dates.push(nextDay.format("MM/DD"));
          }
          return dates;
        }

        if(this.distribution === 'monthly'){
          const dates = [moment(this.startDate).format('MMMM')];
          let currentDate = this.startDate;
          let endDate = moment(this.endDate).format('YYYY-MM');
          while(currentDate < endDate){
            const nextMonth = moment(currentDate).add(1, 'month');
            currentDate = nextMonth.format('YYYY-MM');
            dates.push(nextMonth.format('MMMM'));
          }
          return dates;
        }

        if(this.distribution === 'hourly'){
          const dates = [moment(this.startDate).format('YYYY-MM-DD_hA')];
          let currentDate = this.startDate;
          while (currentDate < this.endDate) {
            const nextHour = moment(currentDate).add(1, 'hour');
            currentDate = nextHour.format('YYYY-MM-DD HH:mm:ss');
            if (currentDate < this.endDate) {
              dates.push(nextHour.format('YYYY-MM-DD_hA'));
            }
          }
          return dates;
        }

        return [];
      },
      buildX() {

        let dateKeys = this.getDatesInRange();
        this.xInterval = 0;

        if(dateKeys.length > this.maxTicks){
          this.xInterval = Math.ceil(dateKeys.length / this.maxTicks)
        }

        const axisColor = this.colorTheme === 'theme-dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0, 0.5)';

        return {
          data: dateKeys,
          boundaryGap: dateKeys.length <= 10,
          axisLabel: {
            interval: this.xInterval
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: axisColor
            }
          },
          axisTick: {
            interval: this.xInterval
          }
        }

      },
      buildY1(){

        const axisColor = this.colorTheme === 'theme-dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0, 0.5)';

        return {
          name: 'Presented Calls (IN)',
          position: 'left',
          splitLine: {show: false},
          axisLine: {
            lineStyle: {
              color: axisColor
            }
          }
        }

      },
      buildY2(){

        const axisColor = this.colorTheme === 'theme-dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0, 0.5)';

        //this will be time or calls or percent based on secondary group.
        const unitsKey = {
          internalCalls: 'Calls (INTERNAL)',
          outboundCalls: 'Calls (OUT)',
          inboundCalls: 'Presented Calls (IN)',
          callQuality: 'Percent',
          talkTime: 'Duration (Min)',
          totalCalls: 'Calls (TOTAL)'
        }

        const axisName = unitsKey[this.secondaryGroup];

        return {
          name: axisName,
          position: 'right',
          splitLine: {show: false},
          axisLine: {
            lineStyle: {
              color: axisColor
            }
          }
        }

      },
      buildPrimary(xAxis){

        this.primaryLegend = [];

        if(this.primaryData){
          const callData = {...this.primaryData.data};

          if(this.primaryFilter === 'user' && this.direction === 'IN'){
            this.dispositions = ['ANSWERED'];
          }

          let dataGroups = {}
          for(let i = 0; i < this.dispositions.length; i++){
            dataGroups[this.dispositions[i]] = [];
          }

          for(let i = 0; i < xAxis.length; i++){
            for(let k = 0; k < this.dispositions.length; k++){
              dataGroups[this.dispositions[k]][i] = 0;
            }

            if(callData.hasOwnProperty(xAxis[i])){
              for(let k = 0; k < callData[xAxis[i]].length; k++){
                const callInfo = callData[xAxis[i]][k];
                dataGroups[callInfo.disposition][i] = callInfo.total;
              }
            }
          }

          let series = [];
          let count = 0;
          for(let group in dataGroups){
            if(dataGroups.hasOwnProperty(group)){
              series.push({
                name: `${group} (${this.direction})`,
                type: xAxis.length > 10 ? 'line' : 'bar',
                symbol: 'circle',
                smooth: true,
                showSymbol: true,
                yAxisIndex: 0,
                symbolRepeat: true,
                symbolSize: 3,
                symbolMargin: 1,
                barMaxWidth: 5,
                z: -10,
                lineStyle: {
                  color: this.colors[count]
                },
                itemStyle: {
                  color: this.colors[count],
                  borderColor: this.colors[count],
                  borderWidth: 3
                },
                data: dataGroups[group]
              });
              this.primaryLegend.push({name: `${group} (${this.direction})`});
              count++;
            }
          }
          return series;
        }

        return [];
      },
      buildSecondary(xAxis){

        const callData = {...this.secondaryData.data};

        const dispositionGroups = ['outboundCalls', 'inboundCalls', 'totalCalls'];

        //need to initialize the data groups here.

        let dataGroups = {}

        //this is the initializing for call type secondaries
        if(dispositionGroups.includes(this.secondaryGroup)){
          for(let i = 0; i < this.secondaryOptions.length; i++){
            dataGroups[this.secondaryOptions[i]] = [];
          }
        }

        for(let i = 0; i < xAxis.length; i++){

          for(let k = 0; k < this.secondaryOptions.length; k++){
            dataGroups[this.secondaryOptions[k]][i] = 0;
          }

          //if this is outboundcalls, inboundcalls this is fine
          if(dispositionGroups.includes(this.secondaryGroup) && callData.hasOwnProperty(xAxis[i])){
            for(let k = 0; k < callData[xAxis[i]].length; k++){
              const callInfo = callData[xAxis[i]][k];
              dataGroups[callInfo.disposition][i] = callInfo.total;
            }
          }

        }

        //loop over the data groups and build out the series
        let series = [];
        let count = 0;
        for(let group in dataGroups){
          if(dataGroups.hasOwnProperty(group)){
            series.push({
              name: `${group} (${this.getSecondaryGroupName(this.secondaryGroup)})`,
              type: 'line',
              symbol: 'circle',
              smooth: true,
              showSymbol: true,
              yAxisIndex: 1,
              symbolRepeat: true,
              symbolSize: 3,
              symbolMargin: 1,
              barMaxWidth: 5,
              z: -10,
              lineStyle: {
                color: this.colorsSecondary[count]
              },
              itemStyle: {
                color: this.colorsSecondary[count],
                borderColor: this.colorsSecondary[count],
                borderWidth: 3
              },
              data: dataGroups[group]
            });
            this.primaryLegend.push({name: `${group} (${this.getSecondaryGroupName(this.secondaryGroup)})`});
            count++;
          }
        }
        return series;


      },
      buildChart(){

        if(this.chart){
          this.chart.dispose();
          this.chart = null;
        }

        this.chart = echarts.init(this.chartElement);

        const xAxis = this.buildX();
        const y1 = this.buildY1();
        const data1 = this.buildPrimary(xAxis.data);

        let y2 = null;
        let data2 = null;
        if(this.secondaryData){
          if(this.secondaryData.data){
            y2 = this.buildY2();
            data2 = this.buildSecondary(xAxis.data);
          }
        }

        const seriesData = data2 ? [...data1, ...data2] : data1;
        const yAxis = y2 ? [y1, y2] : [y1];

        const axisColor = this.colorTheme === 'theme-dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0, 0.5)';

        this.chart.setOption({
          grid: {},
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            }
          },
          xAxis,
          yAxis,
          series: seriesData,
          legend: {
            show: true,
            type: 'scroll',
            orient: 'horizontal',
            icon: 'rectangle',
            itemWidth: 15,
            itemHeight: 3,
            data: this.primaryLegend,
            textStyle: {
              color: axisColor
            }
          }
        });

      },
      queryData(){
        //grab all the data
        this.plotLoading = true;
        feathersClient.service('call-history').find({
          query: {
            queryType: 'callStatistics',
            tenantId: this.selectedTenant.id,
            dateStart: this.startDate,
            dateEnd: this.endDate,
            direction: this.direction,
            dispositions: ['ANSWERED', 'NO ANSWER'],
            primaryName: this.name,
            primaryFilter: this.primaryFilter,
            extNumber: this.extNumber,
            phoneNumber: this.phoneNumber,
            branch: this.branch,
            secondaryGroup: this.secondaryGroup,
            secondaryOptions: this.secondaryOptions,
            presentedFilter: this.presentedFilter,
            timezone: this.user.timezone,
            distribution: this.distribution
          }
        }).then (res => {
          this.primaryData = {...res.primary};
          this.secondaryData = {...res.secondary};
          this.buildChart();
          this.plotLoading = false;
        });
      },
      numberFormatter(val) {
        return phoneNumberFormatter(val);
      }
    },
    mounted() {
      this.chartElement = document.getElementById('activity-plot-'+this.direction);
      this.doPreset('last10');
    },
    beforeDestroy() {
      if(this.chart){
        this.chart.dispose();
        this.chart = null;
      }
      this.chartElement = null;
    }
  }

</script>

<style lang="scss" scoped>

  .el-form{
    .el-select{
      margin-left: 0;
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  .dispositions-group{
    .el-checkbox{
      margin-left: 0;
      display: flex;
      align-items: center;
    }
  }

</style>
